import type { Address } from "viem";

/**
 * Saca la IMPLEMENTACION del bytecode de un clon EIP-1167.
 *
 * Hace falta porque a un clon no se le puede preguntar que firmas entiende: su codigo son 45 bytes
 * que hacen delegatecall a otra direccion. Todo lo que la app decide sobre "que sabe hacer este
 * vault" —si tiene `claimFees`, `addReserve`, `upgradeRebalancer`— sale de comparar esta direccion
 * contra las listas de `networks.ts`.
 *
 * El patron es fijo:  0x363d3d373d3d3d363d73 <20 bytes de impl> 5af43d82803e903d91602b57fd5bf3
 */
const EIP1167 =
  /^0x363d3d373d3d3d363d73([0-9a-f]{40})5af43d82803e903d91602b57fd5bf3$/i;

export function implDeClon(bytecode: string | undefined): Address | undefined {
  if (!bytecode) return undefined;
  const m = EIP1167.exec(bytecode);
  return m ? (`0x${m[1]}` as Address) : undefined;
}
